"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[371],{

/***/ 64847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18518);
/* harmony import */ var _sparkpost_matchbox_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6848);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31955);





var DASHBOARD_LINK = 'https://app.sparkpost.com';
var LOGIN_LINK = 'https://app.sparkpost.com/auth';
var SIGNUP_LINK = 'https://app.sparkpost.com/join?plan=free-0817&sfdcid=7016000000198J1&src=SP-Website';
var AUTH_KEY = 'website_auth';
var HeaderButtons = function() {
    var isLoggedIn = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return !!js_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get(AUTH_KEY);
    }, []);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isLoggedIn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
            as: "a",
            color: "blue",
            variant: "outline",
            href: DASHBOARD_LINK,
            children: [
                "View Your Dashboard",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Button.Icon */ .zx.Icon, {
                    as: _sparkpost_matchbox_icons__WEBPACK_IMPORTED_MODULE_4__/* .OpenInNew */ ._jy,
                    ml: "200"
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Button.Group */ .zx.Group, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                    as: "a",
                    color: "blue",
                    variant: "outline",
                    href: LOGIN_LINK,
                    children: "Login"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                    as: "a",
                    color: "blue",
                    variant: "outline",
                    href: SIGNUP_LINK,
                    children: "Try Now"
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderButtons);


/***/ }),

/***/ 22545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layoutInnerContent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@sparkpost/matchbox/dist/matchbox.esm.js + 50 modules
var matchbox_esm = __webpack_require__(18518);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@sparkpost/matchbox-icons/dist/matchbox-icons.esm.js
var matchbox_icons_esm = __webpack_require__(6848);
// EXTERNAL MODULE: ./node_modules/@sparkpost/design-tokens/index.js
var design_tokens = __webpack_require__(26581);
;// CONCATENATED MODULE: ./components/site/logo.tsx



var Logo = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Box */.xu, {
        height: "700",
        display: "flex",
        alignItems: "flex-end",
        position: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                as: "a",
                display: "block",
                height: "100%",
                href: "https://www.sparkpost.com",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    height: "100%",
                    viewBox: "0 0 500 193",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: design_tokens.tokens.color_brand_gray,
                            d: "m-.1 116.06 7.79-9.33c5.4 4.45 11.05 7.28 17.9 7.28 5.4 0 8.65-2.14 8.65-5.65v-.17c0-3.34-2.06-5.05-12.07-7.62C10.09 97.48 2.3 94.14 2.3 82.23v-.17c0-10.88 8.73-18.07 20.98-18.07 8.73 0 16.18 2.74 22.26 7.62l-6.85 9.93c-5.31-3.68-10.53-5.91-15.58-5.91-5.05 0-7.71 2.31-7.71 5.22v.17c0 3.94 2.57 5.22 12.93 7.88 12.16 3.17 19.01 7.54 19.01 17.98v.17c0 11.9-9.07 18.58-22 18.58-9.09.02-18.25-3.15-25.44-9.57zM55.43 64.85h24.49c14.3 0 22.95 8.48 22.95 20.72v.17c0 13.87-10.79 21.07-24.23 21.07H68.62v17.98H55.43V64.85zm23.63 30.23c6.59 0 10.44-3.94 10.44-9.08v-.17c0-5.91-4.11-9.08-10.7-9.08H68.62v18.33h10.44zM121.53 64.42h12.16l25.69 60.37h-13.79l-5.48-13.44h-25.34l-5.48 13.44H95.84l25.69-60.37zM135.4 99.7l-7.97-19.44-7.96 19.44h15.93zM165.62 64.85h27.4c7.62 0 13.53 2.14 17.47 6.08 3.34 3.34 5.14 8.05 5.14 13.7v.17c0 9.68-5.22 15.76-12.85 18.58l14.64 21.41h-15.41l-12.85-19.18H178.8v19.18h-13.19V64.85zm26.54 29.11c6.42 0 10.1-3.43 10.1-8.48v-.17c0-5.65-3.94-8.56-10.36-8.56h-13.1v17.21h13.36zM285.73 64.85h21.75c13.19 0 22.27 6.76 22.27 18.33v.17c0 12.59-10.88 19.09-23.38 19.09h-16.18v22.35h-4.45V64.85zm20.9 33.48c11.13 0 18.67-5.82 18.67-14.73v-.17c0-9.51-7.36-14.47-18.15-14.47H290.2v29.37h16.43zM401.06 116.06l2.91-3.34c6.59 6.08 12.67 8.91 21.49 8.91 8.99 0 15.16-5.05 15.16-11.9v-.17c0-6.34-3.34-10.02-16.96-12.76-14.38-2.91-20.21-7.79-20.21-16.87v-.17c0-8.91 8.14-15.76 19.27-15.76 8.74 0 14.47 2.4 20.55 7.28l-2.83 3.51c-5.65-4.88-11.3-6.76-17.9-6.76-8.82 0-14.64 5.05-14.64 11.3v.17c0 6.34 3.25 10.19 17.47 13.1 13.87 2.83 19.7 7.79 19.7 16.53v.17c0 9.68-8.31 16.36-19.87 16.36-9.58-.01-16.94-3.18-24.14-9.6zM470.76 68.96h-20.9v-4.11h46.24v4.11h-20.89v55.83h-4.45V68.96zM237.82 90.07l20.75-25.22h16.1l-24.34 28.47 26.1 31.47h-16.96l-21.64-26.76v26.76h-13.19V64.85h13.19v25.22z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: design_tokens.tokens.color_brand_orange,
                            d: "M387.37 51.19c-6.68 5.04-7.97 13.93-8.17 19.93-10.55-12.2 19.54-48.11-14.66-70.3 21.17 27.4-30.12 54.33-30.12 94.69 0 15.82 9.89 29.76 31.6 34.6 21.3-4.53 31.81-18.78 31.81-34.6 0-23.58-14.68-31.47-10.46-44.32zm-21.3 66c-11.6 0-21-9.4-21-21s9.4-21 21-21 21 9.4 21 21c-.01 11.6-9.41 21-21 21z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: design_tokens.tokens.color_brand_gray,
                            d: "m5.52 181.92 2.27-6.39h12.22l2.27 6.39h4.09L16.02 154.5h-4.09L1.58 181.92h3.94zm13.41-9.44H8.87l5.03-14.11 5.03 14.11z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: design_tokens.tokens.color_brand_gray,
                            d: "M47.29 181.92V162.6l6.16 11.99h3.45l6.16-11.99v19.32h5.96V154.5h-7.25l-6.41 12.44L49 154.5h-7.69v27.43h5.98zm38.01.49c4.78.16 9.89-2.68 10.4-7.86h-5.91c-.38 3.65-5.86 4.31-7.9 1.82-.83-.98-1.27-2.49-1.32-4.52H95.8c.14-3.91-.71-7.59-3.45-9.94-3.98-3.19-10.39-3.2-14.33.05-3.73 3.09-4.2 10.13-2.49 14.45 1.56 4.11 5.63 6.05 9.77 6zm4.43-13.86h-9.07c.34-2.85 1.69-4.55 4.53-4.57 2.85.02 4.21 1.72 4.54 4.57zm19.82 13.86c3.24-.02 6.97-.78 8.77-3.69 1-1.47 1.12-4.36.28-5.97-1.09-2.32-3.58-3.25-5.9-3.91-1.93-.78-6.56-.7-6.6-3.15-.01-1.49 1.44-2.06 2.81-2.06 1.8-.03 3.3 1.01 3.4 2.8h6.01c-.19-4.8-4.94-7.02-9.27-6.88-3.05.02-6.58.74-8.24 3.5-1.4 2.29-.91 6.03 1.37 7.59 1.96 1.5 4.86 2.05 7.11 2.63 1.29.34 2.52.57 3.36 1.38.79.83.48 2.46-.52 3.04-2.33 1.5-6.89.37-6.93-2.9h-6.01c.26 5.33 5.53 7.78 10.36 7.62zm23.28 0c3.24-.02 6.97-.78 8.77-3.69 1-1.47 1.12-4.36.28-5.97-1.09-2.32-3.58-3.25-5.9-3.91-1.93-.78-6.56-.7-6.6-3.15-.01-1.49 1.44-2.06 2.81-2.06 1.8-.03 3.3 1.01 3.4 2.8h6.01c-.19-4.8-4.94-7.02-9.27-6.88-3.05.02-6.58.74-8.24 3.5-1.4 2.29-.91 6.03 1.37 7.59 1.96 1.5 4.86 2.05 7.11 2.63 1.29.34 2.52.57 3.36 1.38.79.83.48 2.46-.52 3.04-2.33 1.5-6.89.37-6.93-2.9h-6.01c.27 5.33 5.54 7.78 10.36 7.62zm31.8 0c1.34.01 2.88-.32 3.89-.93v-4.13c-.99.55-3.06.88-2.91-.84v-8.45c.19-5.77-3.22-8.66-8.97-8.5-5.03-.18-10.04 2.34-9.91 8.11h5.72c.02-1.15.29-2.03.81-2.65.67-1 3.42-1.18 4.61-.63 1.79.81 1.65 2.96 1.68 4.71-3.93.5-9.23 0-12.24 3.06-1.64 1.67-1.86 4.86-.91 6.91 2.67 5.08 11.15 3.99 14.23-.09-.21 2.32 1.73 3.53 4 3.43zm-9.76-4.17c-1.04 0-1.79-.21-2.25-.63-1.08-.91-.89-3.23.35-3.92 1.22-.94 4.89-1.06 6.59-1.3v4.08c-1.38 1.09-2.84 1.78-4.69 1.77zm26.47 13.9c3.19-.02 6.29-.41 8.8-1.92 2.93-1.6 4.11-5.61 2.56-8.49-1.51-2.66-4.75-3.29-7.66-3.31-1.56-.11-6.93.34-8.11-.47-1.45-.79-.73-2.43.47-2.97 6.32 2.2 15.43-1.7 13.26-9.54 1.22-.56 2.44-.56 3.94-.59v-5.31c-2.55-.02-4.54.83-5.82 2.75-4.42-4.07-12.94-3.75-16.28 1.57-1.89 3.12-.81 7.93 2.33 9.83-4.1 1.44-4.91 6.36-.69 8.21-2.93.88-4.84 3.97-2.98 6.76 2.25 3.04 6.37 3.4 10.18 3.48zm-.05-20.84c-5.33.28-5.35-7.7-.05-7.47 5.32-.27 5.35 7.71.05 7.47zm.24 17.01c-2.12 0-3.64-.26-4.55-.77-1.89-.91-1.73-3.46.01-4.24h6.95c1.28 0 2.21.16 2.78.49.58.33.86.85.86 1.57-.17 2.76-3.31 2.84-6.05 2.95zm25.58-5.9c4.78.16 9.89-2.68 10.4-7.86h-5.91c-.38 3.65-5.86 4.31-7.9 1.82-.83-.98-1.27-2.49-1.32-4.52h15.23c.14-3.91-.71-7.59-3.45-9.94-3.98-3.19-10.39-3.2-14.33.05-3.73 3.09-4.2 10.13-2.49 14.45 1.57 4.11 5.63 6.05 9.77 6zm4.44-13.86h-9.07c.34-2.85 1.69-4.55 4.53-4.57 2.85.02 4.2 1.72 4.54 4.57zm23.66 13.37c3.5 0 6.15-.69 7.95-2.08 2.86-1.91 3.63-7.27 1.48-9.93-.81-.99-1.95-1.72-3.41-2.2 4.58-1.64 4.48-8.69.89-11.22-1.74-1.34-4.29-2-7.64-2h-11.44v27.43h12.17zm-1.38-16.32h-4.53v-6.19c1.45.06 5.45-.15 6.73.21 2.05.31 2.62 2.46 2.05 4.17-.68 1.64-2.49 1.77-4.25 1.81zm.64 11.41h-5.18v-6.78c1.62.07 6.18-.19 7.6.25 2.24.37 2.94 2.67 2.28 4.56-.75 1.81-2.75 1.92-4.7 1.97zm22.97-22.22v-5.41h-6.41v5.41h6.41zm-.15 27.13v-21.87h-6.11v21.87h6.11zm12.27 0v-15.53c1.68-2.11 5.32-2.16 7.69-1.13v-5.21c-2.99-1.32-6.98-.07-8.38 3v-3h-5.42v21.87h6.11zm19.25.49c2.56.02 5.14-.99 6.51-3.1v2.61h5.42v-32.54h-6.11v12.73c-2.89-3.61-9.15-3.25-12.24.07-3.23 3.28-3.62 9.9-2.14 14.13 1.27 3.84 4.68 6.15 8.56 6.1zm1.82-5.01c-5.53.33-6.03-7.9-3.73-11.19 1.6-2.26 5.8-2.05 7.73-.16v9.88c-1.05.96-2.49 1.48-4 1.47z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: design_tokens.tokens.color_brand_gray,
                            d: "M325.93 182.41c4.61.19 8.59-3.07 8.67-7.82h-3.65c.04 5.04-7.03 6.07-9.64 2.62-1.03-1.34-1.55-3.34-1.55-6.01s.52-4.67 1.55-5.98c2.59-3.39 9.67-2.43 9.64 2.59h3.65c-.14-7.79-10.02-9.96-15.29-5.52-3.4 2.93-3.8 8.67-2.86 12.84.9 4.57 5.01 7.44 9.48 7.28zm23.31 0c9.08.19 11.57-9.35 9.01-16.63-3.11-8.43-16.95-7.36-18.51 1.57-1.6 7.19 1.05 15.2 9.5 15.06zm0-3.19c-4.69-.07-6.13-3.35-6.16-8.01.03-4.67 1.48-7.89 6.16-7.96 4.68.07 6.13 3.29 6.16 7.96-.03 4.65-1.48 7.94-6.16 8.01zm19.86 2.7v-16.51c1.81-2.28 6.64-3.21 8.42-.5.78 1.34.82 2.97.85 4.68v12.34h3.7c-.09-2.24.24-14.18-.25-16.12 1.79-2.46 6.79-3.82 8.7-.87.75 1.34.78 2.97.81 4.66v12.34h3.7v-13.17c-.02-2.91-.46-5.22-2.18-7.05-3.34-2.98-9.34-1.8-11.77 1.74-2.22-4.85-10.04-4.28-12.62-.15v-2.75h-3.06v21.38h3.7zm36.97 9.73v-11.94c2.97 3.52 9.09 3.62 12.22.12 2.06-2.31 2.76-5.27 2.76-8.72.04-4.5-1.47-8.85-5.62-10.47-3.47-1.33-7.76-.4-10.01 2.56v-2.65h-3.06v31.11h3.71zm5.17-12.43c-2.03.02-3.86-.75-5.18-2.11v-11.75c2.3-2.59 7.66-3.03 9.71-.02 2.81 4.07 2.21 14.2-4.53 13.88zm31.8 3.19c1.01.01 2.19-.24 2.96-.69v-2.75c-1.02.61-3.19.95-3.06-.84v-9.78c.14-5.21-2.22-8.49-7.74-8.31-4.66-.18-8.92 2.42-8.72 7.67h3.6c-.23-4.39 3.57-5.37 7.06-4.3 2.32 1 2.05 3.79 2.11 6.02-3.21.38-7.73.22-10.6 1.9-2.61 1.34-3.6 4.66-2.56 7.38 2.17 5.3 10.71 4.46 13.75.39-.2 2.05 1.05 3.4 3.2 3.31zm-9.71-2.9c-1.28 0-2.25-.28-2.91-.85-1.51-1.22-1.23-4.11.41-5.07 1.64-1.29 6.2-1.39 8.42-1.7v5.36c-1.76 1.44-3.55 2.28-5.92 2.26zm21.04 2.41v-16.51c2.02-2.27 7.18-3.22 9.14-.5.83 1.33.88 2.96.91 4.68v12.34h3.7v-13.17c-.02-2.93-.49-5.25-2.29-7.05-3.35-2.83-9.68-2.02-12.1 1.6v-2.75h-3.06v21.38h3.7zm21.52 10.22c4.15.19 6.27-3.23 7.44-6.73l9.12-24.87h-3.8l-5.91 17.45-5.96-17.45h-3.99l7.94 21.87c-1.54 3.95-1.96 7.93-7.29 6.19v3.15c.65.27 1.53.4 2.45.39z"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                mx: "300",
                height: "70%",
                width: "1px",
                bg: "gray.500"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                as: "a",
                display: "block",
                height: "80%",
                href: "https://www.sparkpost.com/docs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    height: "100%",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 150 136",
                    fill: design_tokens.tokens.color_brand_orange,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M5,80.52h9V96.6c1.89-2.68,4.26-5.11,8.39-5.11,6.08,0,9.61,4.36,9.61,11.28v22.75H24v-20c0-3.9-1.82-5.88-4.94-5.88s-5.06,2-5.06,5.88v20H5Z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M38,108.61v-.56c0-9.84,6.13-17,14.48-17,9.47,0,14.11,7.73,14.11,17.63,0,.49,0,1.55-.06,2.85H46.75c.74,4.39,3.46,6.68,7.18,6.68,2.72,0,4.83-1.24,6.93-3.28l4.52,5.32a15.32,15.32,0,0,1-11.82,5.32C44.77,125.56,38,118.94,38,108.61Zm20-3.09c-.37-4.58-2.35-7.42-5.63-7.42s-5.32,2.72-5.82,7.42Z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M72,80.52h9v45H72Z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M89,91.52h9V96.1c1.87-2.78,4.45-5.2,8.73-5.2,6.38,0,12.27,5.38,12.27,16.71v1c0,11.32-5.84,16.71-12.27,16.71-4.33,0-6.92-2.41-8.73-4.89v14.11H89Zm21,17.07V108c0-5.66-2.8-9.27-6.47-9.27S97,102.3,97,108v.62c0,5.66,2.86,9.27,6.53,9.27S110,114.25,110,108.58Z"
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var logo = (Logo);

// EXTERNAL MODULE: ./node_modules/algoliasearch/dist/algoliasearch-lite.umd.js
var algoliasearch_lite_umd = __webpack_require__(70290);
var algoliasearch_lite_umd_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_lite_umd);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/widgets/InstantSearch.js + 5 modules
var InstantSearch = __webpack_require__(56843);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectSearchBox.js
var connectSearchBox = __webpack_require__(74575);
;// CONCATENATED MODULE: ./components/site/algolia/searchBox.tsx




var Input = function(param) {
    var currentRefinement = param.currentRefinement, onFocus = param.onFocus, hasFocus = param.hasFocus, refine = param.refine;
    (0,matchbox_esm/* useWindowEvent */.sm)('keydown', function(e) {
        if (hasFocus && e.key === 'Escape') {
            refine('');
        }
    });
    var onSubmit = function(e) {
        e.preventDefault();
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        noValidate: true,
        action: "",
        autoComplete: "off",
        role: "search",
        onSubmit: onSubmit,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* TextField */.nv, {
            id: "algolia-search",
            label: "Search",
            prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_icons_esm/* Search */.olm, {}),
            placeholder: "e.g. Getting Started",
            value: currentRefinement,
            onChange: function(event) {
                return refine(event.currentTarget.value);
            },
            onFocus: onFocus
        })
    }));
};
var SearchBox = (0,connectSearchBox/* default */.Z)(Input);
/* harmony default export */ var searchBox = (SearchBox);

// EXTERNAL MODULE: ./context/categories.tsx
var context_categories = __webpack_require__(18650);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectStateResults.js
var connectStateResults = __webpack_require__(98617);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-dom/dist/es/widgets/Highlight.js + 3 modules
var Highlight = __webpack_require__(28568);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-dom/dist/es/widgets/Hits.js + 2 modules
var Hits = __webpack_require__(14606);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/@styled-system/css/dist/index.esm.js
var index_esm = __webpack_require__(37947);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./utils/string.ts
var string = __webpack_require__(14045);
;// CONCATENATED MODULE: ./components/site/algolia/results.tsx










function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  .ais-Hits-item {\n    margin: 0;\n    cursor: pointer;\n  }\n\n  .ais-Highlight-highlighted,\n  .ais-Snippet-highlighted {\n    ",
        "\n    color: inherit;\n  }\n\n  ul {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  text-decoration: none;\n\n  ",
        "\n\n  &:hover, &:focus {\n    outline: none;\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var ResultsWrapper = styled_components_browser_esm["default"].div(_templateObject(), (0,index_esm/* default */.ZP)({
    bg: 'yellow.200'
}));
var ResultCount = (0,connectStateResults/* default */.Z)(function(param) {
    var searchResults = param.searchResults;
    var resultCount = searchResults && searchResults.nbHits;
    return resultCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
        fontSize: "200",
        lineHeight: "200",
        p: "200",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                resultCount,
                " result",
                resultCount > 1 ? 's' : ''
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
        fontSize: "200",
        lineHeight: "200",
        p: "200",
        children: "No Results"
    });
});
var StyledLink = styled_components_browser_esm["default"].a(_templateObject1(), (0,index_esm/* default */.ZP)({
    py: '400',
    px: '300'
}), (0,index_esm/* default */.ZP)({
    bg: 'blue.200'
}));
var Result = function(param1) {
    var hit = param1.hit;
    var parts = hit.slug.split('/');
    var crumbLength = parts.length - 1;
    var crumbs = parts.slice(1, crumbLength);
    var categories = react.useContext(context_categories/* CategoriesContext */.i);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: hit.slug,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
            href: hit.slug,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Stack */.Kq, {
                space: "100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Box */.xu, {
                        fontSize: "400",
                        color: "gray.900",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                                attribute: "title",
                                hit: hit,
                                tagName: "mark"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                                fontSize: "200",
                                color: "gray.700",
                                style: {
                                    whiteSpace: 'nowrap'
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Inline */.gF, {
                                    space: "100",
                                    children: [
                                        "In",
                                        crumbs.map(function(crumb, i) {
                                            var category = categories.find(function(param) {
                                                var key = param.key;
                                                return key === crumb;
                                            });
                                            var label = (category === null || category === void 0 ? void 0 : category.label) || (0,string/* toTitleCase */.LF)(crumb);
                                            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    label,
                                                    " ",
                                                    i !== crumbs.length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_icons_esm/* ChevronRight */._Qn, {
                                                        size: 16
                                                    }) : null
                                                ]
                                            }, i));
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                        fontSize: "100",
                        lineHeight: "100",
                        color: "gray.700",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                            attribute: "description",
                            hit: hit,
                            tagName: "mark"
                        })
                    })
                ]
            })
        })
    }));
};
var SearchResults = /*#__PURE__*/ react.forwardRef(function SearchResults(props, ref) {
    var show = props.show;
    if (!show) {
        return null;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Box */.xu, {
            position: "absolute",
            width: "100%",
            bg: "white",
            border: "400",
            borderRadius: "200",
            boxShadow: "400",
            top: "100%",
            mt: "200",
            maxHeight: [
                '400px',
                null,
                '70vh'
            ],
            overflow: "auto",
            zIndex: "1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultCount, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultsWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hits/* default */.Z, {
                        hitComponent: Result
                    })
                })
            ]
        })
    }));
});
/* harmony default export */ var results = (SearchResults);

;// CONCATENATED MODULE: ./components/site/algolia/search.tsx







function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Search = function(props) {
    var appId = "SFXAWCYDV8" || 0;
    var searchKey = "9ba87280f36f539fcc0a318c2d4fcfe6" || 0;
    var searchClient = algoliasearch_lite_umd_default()(appId, searchKey);
    var ref3 = _slicedToArray(react.useState(''), 2), query1 = ref3[0], setQuery = ref3[1];
    var ref1 = _slicedToArray(react.useState(false), 2), hasFocus = ref1[0], setHasFocus = ref1[1];
    var container = react.useRef(null);
    var menu = react.useRef(null);
    (0,matchbox_esm/* useWindowEvent */.sm)('click', function(e) {
        var ref, ref2;
        var isInside = container && ((ref = container.current) === null || ref === void 0 ? void 0 : ref.contains(e.target));
        var isInsideMenu = menu && ((ref2 = menu.current) === null || ref2 === void 0 ? void 0 : ref2.contains(e.target));
        if (hasFocus && !isInside || isInsideMenu) {
            setHasFocus(false);
        }
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
        ref: container,
        position: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InstantSearch/* default */.Z, {
            searchClient: searchClient,
            indexName: props.indexName,
            onSearchStateChange: function(param) {
                var query = param.query;
                return setQuery(query);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(searchBox, {
                    onFocus: function() {
                        return setHasFocus(true);
                    },
                    hasFocus: hasFocus
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(results, {
                    ref: menu,
                    show: (query1 === null || query1 === void 0 ? void 0 : query1.length) > 0 && hasFocus
                })
            ]
        })
    }));
};
/* harmony default export */ var search = (Search);

// EXTERNAL MODULE: ./components/site/headerButtons.tsx
var headerButtons = __webpack_require__(64847);
;// CONCATENATED MODULE: ./components/site/header.tsx









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function header_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function header_templateObject() {
    var data = header_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledButton = styled_components_browser_esm["default"].button(header_templateObject(), matchbox_esm/* styles.buttonReset */.W2.buttonReset);
var Header = function(props) {
    var getActivatorProps = props.getActivatorProps;
    var asPath = (0,router.useRouter)().asPath;
    var category = asPath.split('/')[1];
    var searchBox = /*#__PURE__*/ (0,jsx_runtime.jsx)(search, {
        indexName: "next_support_documentation"
    });
    if (category === 'momentum') {
        searchBox = /*#__PURE__*/ (0,jsx_runtime.jsx)(search, {
            indexName: "next_momentum_documentation"
        });
    } else if (category === 'analyst') {
        searchBox = /*#__PURE__*/ (0,jsx_runtime.jsx)(search, {
            indexName: "next_analyst_documentation"
        });
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Box */.xu, {
        my: "600",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Box */.xu, {
                as: "header",
                height: "650",
                display: "flex",
                justifyContent: "space-between",
                mb: "500",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {}),
                    getActivatorProps && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                                display: [
                                    'block',
                                    null,
                                    'none'
                                ],
                                marginTop: "15px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButton, _objectSpread({}, getActivatorProps(), {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* ScreenReaderOnly */.uy, {
                                            children: "Open Menu"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_icons_esm/* Menu */.v2r, {
                                            size: 24
                                        })
                                    ]
                                }))
                            }),
                            !props.hideDrawerButtons && /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                                display: [
                                    'none',
                                    null,
                                    'block'
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(headerButtons/* default */.Z, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                maxWidth: "1150",
                children: searchBox
            })
        ]
    }));
};
/* harmony default export */ var header = (Header);

;// CONCATENATED MODULE: ./components/site/layoutInnerContent.tsx




function layoutInnerContent_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function layoutInnerContent_templateObject() {
    var data = layoutInnerContent_taggedTemplateLiteral([
        "\n  opacity: 0;\n  text-decoration: none;\n  z-index: -1;\n  &:focus {\n    opacity: 1;\n    z-index: 1;\n    color: white;\n  }\n"
    ]);
    layoutInnerContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSkipToContent = (0,styled_components_browser_esm["default"])(matchbox_esm/* Box */.xu)(layoutInnerContent_templateObject());
var LayoutInnerContent = function(props) {
    var children = props.children, getActivatorProps = props.getActivatorProps;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSkipToContent, {
                as: "a",
                href: "#main-content",
                position: "absolute",
                display: "inline-block",
                p: "200",
                top: "0",
                left: "0",
                bg: "blue.700",
                children: "Skip to main content"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {
                getActivatorProps: getActivatorProps,
                hideDrawerButtons: props.hideDrawerButtons
            }),
            children
        ]
    }));
};
/* harmony default export */ var layoutInnerContent = (LayoutInnerContent);


/***/ }),

/***/ 34109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layoutWrap; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@sparkpost/matchbox/dist/matchbox.esm.js + 50 modules
var matchbox_esm = __webpack_require__(18518);
;// CONCATENATED MODULE: ./components/site/logoWhite.tsx

var LogoWhite = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "118",
        height: "46",
        viewBox: "0 0 500 193",
        fill: "white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m-.1 116.06 7.79-9.33c5.4 4.45 11.05 7.28 17.9 7.28 5.4 0 8.65-2.14 8.65-5.65v-.17c0-3.34-2.06-5.05-12.07-7.62C10.09 97.48 2.3 94.14 2.3 82.23v-.17c0-10.88 8.73-18.07 20.98-18.07 8.73 0 16.18 2.74 22.26 7.62l-6.85 9.93c-5.31-3.68-10.53-5.91-15.58-5.91-5.05 0-7.71 2.31-7.71 5.22v.17c0 3.94 2.57 5.22 12.93 7.88 12.16 3.17 19.01 7.54 19.01 17.98v.17c0 11.9-9.07 18.58-22 18.58-9.09.02-18.25-3.15-25.44-9.57zM55.43 64.85h24.49c14.3 0 22.95 8.48 22.95 20.72v.17c0 13.87-10.79 21.07-24.23 21.07H68.62v17.98H55.43V64.85zm23.63 30.23c6.59 0 10.44-3.94 10.44-9.08v-.17c0-5.91-4.11-9.08-10.7-9.08H68.62v18.33h10.44zM121.53 64.42h12.16l25.69 60.37h-13.79l-5.48-13.44h-25.34l-5.48 13.44H95.84l25.69-60.37zM135.4 99.7l-7.97-19.44-7.96 19.44h15.93zM165.62 64.85h27.4c7.62 0 13.53 2.14 17.47 6.08 3.34 3.34 5.14 8.05 5.14 13.7v.17c0 9.68-5.22 15.76-12.85 18.58l14.64 21.41h-15.41l-12.85-19.18H178.8v19.18h-13.19V64.85zm26.54 29.11c6.42 0 10.1-3.43 10.1-8.48v-.17c0-5.65-3.94-8.56-10.36-8.56h-13.1v17.21h13.36zM285.73 64.85h21.75c13.19 0 22.27 6.76 22.27 18.33v.17c0 12.59-10.88 19.09-23.38 19.09h-16.18v22.35h-4.45V64.85zm20.9 33.48c11.13 0 18.67-5.82 18.67-14.73v-.17c0-9.51-7.36-14.47-18.15-14.47H290.2v29.37h16.43zM401.06 116.06l2.91-3.34c6.59 6.08 12.67 8.91 21.49 8.91 8.99 0 15.16-5.05 15.16-11.9v-.17c0-6.34-3.34-10.02-16.96-12.76-14.38-2.91-20.21-7.79-20.21-16.87v-.17c0-8.91 8.14-15.76 19.27-15.76 8.74 0 14.47 2.4 20.55 7.28l-2.83 3.51c-5.65-4.88-11.3-6.76-17.9-6.76-8.82 0-14.64 5.05-14.64 11.3v.17c0 6.34 3.25 10.19 17.47 13.1 13.87 2.83 19.7 7.79 19.7 16.53v.17c0 9.68-8.31 16.36-19.87 16.36-9.58-.01-16.94-3.18-24.14-9.6zM470.76 68.96h-20.9v-4.11h46.24v4.11h-20.89v55.83h-4.45V68.96zM237.82 90.07l20.75-25.22h16.1l-24.34 28.47 26.1 31.47h-16.96l-21.64-26.76v26.76h-13.19V64.85h13.19v25.22z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M387.37 51.19c-6.68 5.04-7.97 13.93-8.17 19.93-10.55-12.2 19.54-48.11-14.66-70.3 21.17 27.4-30.12 54.33-30.12 94.69 0 15.82 9.89 29.76 31.6 34.6 21.3-4.53 31.81-18.78 31.81-34.6 0-23.58-14.68-31.47-10.46-44.32zm-21.3 66c-11.6 0-21-9.4-21-21s9.4-21 21-21 21 9.4 21 21c-.01 11.6-9.41 21-21 21z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "m5.52 181.92 2.27-6.39h12.22l2.27 6.39h4.09L16.02 154.5h-4.09L1.58 181.92h3.94zm13.41-9.44H8.87l5.03-14.11 5.03 14.11z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M47.29 181.92V162.6l6.16 11.99h3.45l6.16-11.99v19.32h5.96V154.5h-7.25l-6.41 12.44L49 154.5h-7.69v27.43h5.98zm38.01.49c4.78.16 9.89-2.68 10.4-7.86h-5.91c-.38 3.65-5.86 4.31-7.9 1.82-.83-.98-1.27-2.49-1.32-4.52H95.8c.14-3.91-.71-7.59-3.45-9.94-3.98-3.19-10.39-3.2-14.33.05-3.73 3.09-4.2 10.13-2.49 14.45 1.56 4.11 5.63 6.05 9.77 6zm4.43-13.86h-9.07c.34-2.85 1.69-4.55 4.53-4.57 2.85.02 4.21 1.72 4.54 4.57zm19.82 13.86c3.24-.02 6.97-.78 8.77-3.69 1-1.47 1.12-4.36.28-5.97-1.09-2.32-3.58-3.25-5.9-3.91-1.93-.78-6.56-.7-6.6-3.15-.01-1.49 1.44-2.06 2.81-2.06 1.8-.03 3.3 1.01 3.4 2.8h6.01c-.19-4.8-4.94-7.02-9.27-6.88-3.05.02-6.58.74-8.24 3.5-1.4 2.29-.91 6.03 1.37 7.59 1.96 1.5 4.86 2.05 7.11 2.63 1.29.34 2.52.57 3.36 1.38.79.83.48 2.46-.52 3.04-2.33 1.5-6.89.37-6.93-2.9h-6.01c.26 5.33 5.53 7.78 10.36 7.62zm23.28 0c3.24-.02 6.97-.78 8.77-3.69 1-1.47 1.12-4.36.28-5.97-1.09-2.32-3.58-3.25-5.9-3.91-1.93-.78-6.56-.7-6.6-3.15-.01-1.49 1.44-2.06 2.81-2.06 1.8-.03 3.3 1.01 3.4 2.8h6.01c-.19-4.8-4.94-7.02-9.27-6.88-3.05.02-6.58.74-8.24 3.5-1.4 2.29-.91 6.03 1.37 7.59 1.96 1.5 4.86 2.05 7.11 2.63 1.29.34 2.52.57 3.36 1.38.79.83.48 2.46-.52 3.04-2.33 1.5-6.89.37-6.93-2.9h-6.01c.27 5.33 5.54 7.78 10.36 7.62zm31.8 0c1.34.01 2.88-.32 3.89-.93v-4.13c-.99.55-3.06.88-2.91-.84v-8.45c.19-5.77-3.22-8.66-8.97-8.5-5.03-.18-10.04 2.34-9.91 8.11h5.72c.02-1.15.29-2.03.81-2.65.67-1 3.42-1.18 4.61-.63 1.79.81 1.65 2.96 1.68 4.71-3.93.5-9.23 0-12.24 3.06-1.64 1.67-1.86 4.86-.91 6.91 2.67 5.08 11.15 3.99 14.23-.09-.21 2.32 1.73 3.53 4 3.43zm-9.76-4.17c-1.04 0-1.79-.21-2.25-.63-1.08-.91-.89-3.23.35-3.92 1.22-.94 4.89-1.06 6.59-1.3v4.08c-1.38 1.09-2.84 1.78-4.69 1.77zm26.47 13.9c3.19-.02 6.29-.41 8.8-1.92 2.93-1.6 4.11-5.61 2.56-8.49-1.51-2.66-4.75-3.29-7.66-3.31-1.56-.11-6.93.34-8.11-.47-1.45-.79-.73-2.43.47-2.97 6.32 2.2 15.43-1.7 13.26-9.54 1.22-.56 2.44-.56 3.94-.59v-5.31c-2.55-.02-4.54.83-5.82 2.75-4.42-4.07-12.94-3.75-16.28 1.57-1.89 3.12-.81 7.93 2.33 9.83-4.1 1.44-4.91 6.36-.69 8.21-2.93.88-4.84 3.97-2.98 6.76 2.25 3.04 6.37 3.4 10.18 3.48zm-.05-20.84c-5.33.28-5.35-7.7-.05-7.47 5.32-.27 5.35 7.71.05 7.47zm.24 17.01c-2.12 0-3.64-.26-4.55-.77-1.89-.91-1.73-3.46.01-4.24h6.95c1.28 0 2.21.16 2.78.49.58.33.86.85.86 1.57-.17 2.76-3.31 2.84-6.05 2.95zm25.58-5.9c4.78.16 9.89-2.68 10.4-7.86h-5.91c-.38 3.65-5.86 4.31-7.9 1.82-.83-.98-1.27-2.49-1.32-4.52h15.23c.14-3.91-.71-7.59-3.45-9.94-3.98-3.19-10.39-3.2-14.33.05-3.73 3.09-4.2 10.13-2.49 14.45 1.57 4.11 5.63 6.05 9.77 6zm4.44-13.86h-9.07c.34-2.85 1.69-4.55 4.53-4.57 2.85.02 4.2 1.72 4.54 4.57zm23.66 13.37c3.5 0 6.15-.69 7.95-2.08 2.86-1.91 3.63-7.27 1.48-9.93-.81-.99-1.95-1.72-3.41-2.2 4.58-1.64 4.48-8.69.89-11.22-1.74-1.34-4.29-2-7.64-2h-11.44v27.43h12.17zm-1.38-16.32h-4.53v-6.19c1.45.06 5.45-.15 6.73.21 2.05.31 2.62 2.46 2.05 4.17-.68 1.64-2.49 1.77-4.25 1.81zm.64 11.41h-5.18v-6.78c1.62.07 6.18-.19 7.6.25 2.24.37 2.94 2.67 2.28 4.56-.75 1.81-2.75 1.92-4.7 1.97zm22.97-22.22v-5.41h-6.41v5.41h6.41zm-.15 27.13v-21.87h-6.11v21.87h6.11zm12.27 0v-15.53c1.68-2.11 5.32-2.16 7.69-1.13v-5.21c-2.99-1.32-6.98-.07-8.38 3v-3h-5.42v21.87h6.11zm19.25.49c2.56.02 5.14-.99 6.51-3.1v2.61h5.42v-32.54h-6.11v12.73c-2.89-3.61-9.15-3.25-12.24.07-3.23 3.28-3.62 9.9-2.14 14.13 1.27 3.84 4.68 6.15 8.56 6.1zm1.82-5.01c-5.53.33-6.03-7.9-3.73-11.19 1.6-2.26 5.8-2.05 7.73-.16v9.88c-1.05.96-2.49 1.48-4 1.47z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M325.93 182.41c4.61.19 8.59-3.07 8.67-7.82h-3.65c.04 5.04-7.03 6.07-9.64 2.62-1.03-1.34-1.55-3.34-1.55-6.01s.52-4.67 1.55-5.98c2.59-3.39 9.67-2.43 9.64 2.59h3.65c-.14-7.79-10.02-9.96-15.29-5.52-3.4 2.93-3.8 8.67-2.86 12.84.9 4.57 5.01 7.44 9.48 7.28zm23.31 0c9.08.19 11.57-9.35 9.01-16.63-3.11-8.43-16.95-7.36-18.51 1.57-1.6 7.19 1.05 15.2 9.5 15.06zm0-3.19c-4.69-.07-6.13-3.35-6.16-8.01.03-4.67 1.48-7.89 6.16-7.96 4.68.07 6.13 3.29 6.16 7.96-.03 4.65-1.48 7.94-6.16 8.01zm19.86 2.7v-16.51c1.81-2.28 6.64-3.21 8.42-.5.78 1.34.82 2.97.85 4.68v12.34h3.7c-.09-2.24.24-14.18-.25-16.12 1.79-2.46 6.79-3.82 8.7-.87.75 1.34.78 2.97.81 4.66v12.34h3.7v-13.17c-.02-2.91-.46-5.22-2.18-7.05-3.34-2.98-9.34-1.8-11.77 1.74-2.22-4.85-10.04-4.28-12.62-.15v-2.75h-3.06v21.38h3.7zm36.97 9.73v-11.94c2.97 3.52 9.09 3.62 12.22.12 2.06-2.31 2.76-5.27 2.76-8.72.04-4.5-1.47-8.85-5.62-10.47-3.47-1.33-7.76-.4-10.01 2.56v-2.65h-3.06v31.11h3.71zm5.17-12.43c-2.03.02-3.86-.75-5.18-2.11v-11.75c2.3-2.59 7.66-3.03 9.71-.02 2.81 4.07 2.21 14.2-4.53 13.88zm31.8 3.19c1.01.01 2.19-.24 2.96-.69v-2.75c-1.02.61-3.19.95-3.06-.84v-9.78c.14-5.21-2.22-8.49-7.74-8.31-4.66-.18-8.92 2.42-8.72 7.67h3.6c-.23-4.39 3.57-5.37 7.06-4.3 2.32 1 2.05 3.79 2.11 6.02-3.21.38-7.73.22-10.6 1.9-2.61 1.34-3.6 4.66-2.56 7.38 2.17 5.3 10.71 4.46 13.75.39-.2 2.05 1.05 3.4 3.2 3.31zm-9.71-2.9c-1.28 0-2.25-.28-2.91-.85-1.51-1.22-1.23-4.11.41-5.07 1.64-1.29 6.2-1.39 8.42-1.7v5.36c-1.76 1.44-3.55 2.28-5.92 2.26zm21.04 2.41v-16.51c2.02-2.27 7.18-3.22 9.14-.5.83 1.33.88 2.96.91 4.68v12.34h3.7v-13.17c-.02-2.93-.49-5.25-2.29-7.05-3.35-2.83-9.68-2.02-12.1 1.6v-2.75h-3.06v21.38h3.7zm21.52 10.22c4.15.19 6.27-3.23 7.44-6.73l9.12-24.87h-3.8l-5.91 17.45-5.96-17.45h-3.99l7.94 21.87c-1.54 3.95-1.96 7.93-7.29 6.19v3.15c.65.27 1.53.4 2.45.39z"
            })
        ]
    }));
};
/* harmony default export */ var logoWhite = (LogoWhite);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./components/site/footer.tsx




function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  list-style: none;\n  a {\n    color: inherit;\n    text-decoration: none;\n    &:visited {\n      color: inherit;\n    }\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledNav = (0,styled_components_browser_esm["default"])(matchbox_esm/* Box */.xu)(_templateObject());
var Footer = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
        as: "footer",
        pt: "750",
        pb: "800",
        backgroundColor: "gray.900",
        color: "white",
        display: "flex",
        justifyContent: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Box */.xu, {
            width: "100%",
            maxWidth: "1400",
            px: "400",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                    as: "hr",
                    mt: "800",
                    mb: "400",
                    backgroundColor: "white"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Box */.xu, {
                    display: "flex",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(logoWhite, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNav, {
                            as: "ul",
                            fontSize: "300",
                            fontWeight: "semibold",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                                    as: "li",
                                    display: [
                                        'block',
                                        null,
                                        'inline-block'
                                    ],
                                    pl: "600",
                                    mt: [
                                        '200',
                                        null,
                                        '0'
                                    ],
                                    mb: [
                                        '300',
                                        null,
                                        '0'
                                    ],
                                    color: "white",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.sparkpost.com/features",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "Features"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                                    as: "li",
                                    display: [
                                        'block',
                                        null,
                                        'inline-block'
                                    ],
                                    pl: "600",
                                    mb: [
                                        '300',
                                        null,
                                        '0'
                                    ],
                                    color: "white",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.sparkpost.com/pricing",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "Pricing"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                                    as: "li",
                                    display: [
                                        'block',
                                        null,
                                        'inline-block'
                                    ],
                                    pl: "600",
                                    mb: [
                                        '300',
                                        null,
                                        '0'
                                    ],
                                    color: "white",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.sparkpost.com/blog",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "Blog"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var footer = (Footer);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 2 modules
var AnimatePresence = __webpack_require__(14332);
// EXTERNAL MODULE: ./context/alerts.tsx
var alerts = __webpack_require__(33755);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 167 modules
var motion = __webpack_require__(75377);
// EXTERNAL MODULE: ./node_modules/@styled-system/css/dist/index.esm.js
var index_esm = __webpack_require__(37947);
;// CONCATENATED MODULE: ./components/site/alert.tsx







function alert_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function alert_templateObject() {
    var data = alert_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    alert_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var DISMISS_MILLISECONDS = 3000;
var MotionBox = (0,styled_components_browser_esm["default"])((0,motion/* motion */.E)(matchbox_esm/* Box */.xu))(alert_templateObject(), (0,index_esm/* default */.ZP)({
    pt: '500'
}));
var Alert = function(props) {
    var id = props.id, title = props.title, status = props.status;
    var dispatch = (0,react.useContext)(alerts/* AlertsContext */.Y).dispatch;
    (0,react.useEffect)(function() {
        setTimeout(function() {
            dispatch({
                type: 'removeAlert',
                id: id
            });
        }, DISMISS_MILLISECONDS);
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(MotionBox, {
        initial: {
            y: -100,
            opacity: 0
        },
        animate: {
            y: 0,
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        transition: {
            duration: 0.8,
            ease: [
                0,
                1,
                0.25,
                1
            ]
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Snackbar */.A9, {
            onDismiss: function() {
                return dispatch({
                    type: 'removeAlert',
                    id: id
                });
            },
            status: status,
            children: title
        })
    }, id));
};
/* harmony default export */ var site_alert = (Alert);

;// CONCATENATED MODULE: ./components/site/alerts.tsx






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Alerts = function() {
    var state = (0,react.useContext)(alerts/* AlertsContext */.Y).state;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
        position: "fixed",
        right: "500",
        top: "0px",
        display: "flex",
        flexDirection: "column",
        zIndex: "100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            children: state.alerts.map(function(alert) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(site_alert, _objectSpread({}, alert), alert.id));
            })
        })
    }));
};
/* harmony default export */ var site_alerts = (Alerts);

;// CONCATENATED MODULE: ./components/site/layoutWrap.tsx




var LayoutWrap = function(props) {
    var children = props.children, bg = props.bg;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Box */.xu, {
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        bg: bg ? bg : 'gray.100',
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(site_alerts, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                flex: "1",
                mx: "auto",
                px: "400",
                maxWidth: "1400",
                width: "100%",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {})
        ]
    }));
};
/* harmony default export */ var layoutWrap = (LayoutWrap);


/***/ }),

/***/ 51289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);



var SEO = function(props) {
    var _title = props.title, title = _title === void 0 ? "SparkPost Support" : _title, _description = props.description, description = _description === void 0 ? "SparkPost Support Docs" : _description;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "x-ua-compatible",
                content: "ie=edge"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: router.asPath
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "shortcut icon",
                type: "image/png",
                href: "/favicon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "og:site_name",
                        content: title
                    })
                ]
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:locale",
                content: "en_US"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:url",
                content: router.asPath
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:site_name",
                content: "SparkPost Support"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "SparkPost Support"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "article"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "/SparkPostLogo.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: "/SparkPostLogo.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 18650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ CategoriesContext; },
/* harmony export */   "z": function() { return /* binding */ CategoriesProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var CategoriesContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext([]);
var CategoriesProvider = function(props) {
    var children = props.children, _data = props.data, data = _data === void 0 ? [] : _data;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CategoriesContext.Provider, {
        value: data,
        children: children
    }));
};


/***/ }),

/***/ 14045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lV": function() { return /* binding */ slugify; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "LF": function() { return /* binding */ toTitleCase; }
/* harmony export */ });
/**
 * Slugifies a string
 */ var slugify = function(str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();
    // remove accents, swap ñ for n, etc
    var from = '\xe0\xe1\xe4\xe2\xe8\xe9\xeb\xea\xec\xed\xef\xee\xf2\xf3\xf6\xf4\xf9\xfa\xfc\xfb\xf1\xe7\xb7/_,:;';
    var to = 'aaaaeeeeiiiioooouuuunc------';
    for(var i = 0, l = from.length; i < l; i++){
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }
    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes
    return str;
};
var formatDate = function(date) {
    return new Date(date).toLocaleDateString('en-us', {
        month: 'long',
        year: 'numeric'
    });
};
var toTitleCase = function(str) {
    return str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};


/***/ })

}]);